import { FUND_INVESTMENTS_TITLE_SINGULAR } from 'pages/FundInvestments/common/constants';

export const BULK_ACTIONS = 'Bulk Actions';
export const EDIT_COMPANY = 'Edit Company';
export const EDIT_COMMON_PROFILE = 'Edit Common Profile';
export const EDIT_FUND_INVESTMENT = `Edit ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const EXCEL_EXPORT = 'Excel Export';
export const PDF_EXPORT = 'PDF Export';
export const SAVE = 'Save';

export const FIRM_ACTION_QUERY_PARAM = 'firm-action';
export const FIRM_PAGE_ACTIONS = {
  BULK_ACTIONS: 'bulk-actions',
  EXCEL_EXPORT: 'excel-export',
  PDF_EXPORT: 'pdf-export',
} as const;

export type FirmPageAction = typeof FIRM_PAGE_ACTIONS[keyof typeof FIRM_PAGE_ACTIONS];

export const isFirmPageAction = (value: string | null): value is FirmPageAction =>
  Object.values(FIRM_PAGE_ACTIONS).some(action => action === value);
